var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._g({tag:"component",class:['add-btn list-group-item', _vm.disabledClass],attrs:{"disabled":_vm.isDisabled}},_vm.$listeners),[_c('span',{staticClass:"text-success fas fa-plus-circle mr-5"}),_vm._v(" "),_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }